import { render, staticRenderFns } from "./WorkerEdit.vue?vue&type=template&id=436b400e&scoped=true"
import script from "./WorkerEdit.vue?vue&type=script&lang=ts"
export * from "./WorkerEdit.vue?vue&type=script&lang=ts"
import style0 from "./WorkerEdit.vue?vue&type=style&index=0&id=436b400e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b400e",
  null
  
)

export default component.exports